import React from 'react';
import Modalheader from 'components/modal/components/header';
import ModalBody from 'components/modal/components/body';
import ModalFooter from 'components/modal/components/footer';
import Button from 'components/button';
import Banner from 'components/banner/banner';
import useModal from 'components/modal/useModal';
import UseContext from 'hooks/useContext';

const ConfirmTimeSheetStatusChange = () => {
  const { toggle } = useModal();
  const { modalData, setModalDataReturn } = UseContext();
  const isImportedConfirm = modalData?.confirmReason === 'imported';

  const handleConfirm = () => {
    setModalDataReturn({
      type: 'ts_status_change_confirmed',
      targetStatus: modalData?.targetStatus,
    });
    toggle();
  };

  return (
    <>
      <Modalheader hide={toggle} hideShow={true}>
        Changer le statut du relevé ?
      </Modalheader>
      <ModalBody>
        <div className="flex flex-col gap-3">
          <Banner type="warning">
            {isImportedConfirm ? (
              <>
                Ce relevé est marqué comme <strong>importé</strong>.
              </>
            ) : (
              <>
                Ce relevé est <strong>non complété</strong> et contient des jours vides.
              </>
            )}
          </Banner>
          <p className="text-sm text-gray-700">
            {isImportedConfirm
              ? 'Le changement de statut le repassera en non importé. Voulez-vous continuer ?'
              : 'Voulez-vous vraiment changer son statut ?'}
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button size="LG" color="SECONDARY" onClick={toggle}>
          Annuler
        </Button>
        <Button size="LG" onClick={handleConfirm}>
          Confirmer
        </Button>
      </ModalFooter>
    </>
  );
};

export default ConfirmTimeSheetStatusChange;
